<template>
  <div class="top-layout-main">
    <!-- <transition name="slide-up"> -->
    <div class="top-layout-banner" v-if="showBanner && bannerRef.length > 0">
      <el-carousel
        class="banner"
        trigger="click"
        :autoplay="bannerRef.length > 1"
        height="100px"
        indicator-position="none"
        arrow="never"
        motion-blur
      >
        <el-carousel-item
          class="banner-item"
          v-for="item in bannerRef"
          :key="item.id"
          @click.stop="clickBanner(item)"
        >
          <img class="banner-img" :src="item.imagePath" alt="" />
        </el-carousel-item>
      </el-carousel>
      <div class="banner-but" @click.stop="closeBanner">
        <el-icon size="25" color="#fff">
          <Close />
        </el-icon>
      </div>
    </div>
    <!-- </transition> -->

    <YtHead></YtHead>
    <div class="top-layout-content-box">
      <router-view></router-view>
    </div>
    <el-backtop :right="100" :bottom="140" target=".top-layout-content-box">
      <el-icon>
        <ArrowUpBold />
      </el-icon>
    </el-backtop>
  </div>
</template>

<script setup lang="ts">
import { Close } from '@element-plus/icons-vue'
import YtHead from '../layout/YtHead.vue'
import { onMounted, ref } from 'vue'
import http from '@/utils/http'
import { ArrowUpBold } from '@element-plus/icons-vue'
import { openDefaultQr } from '@/components/imagePopup/index'

const bannerRef = ref<any>([])
const showBanner = ref(true)

const closeBanner = () => {
  showBanner.value = false
}

const clickBanner = (item: any) => {
  if (item.dynamicData) {
    window.open(item.dynamicData, '_blank')
  } else {
    openDefaultQr()
  }
}

onMounted(() => {
  getWindow()
})

const getWindow = () => {
  http.get('/api/appIndex/getHomeBanner', { clientType: 3 }).then((res) => {
    bannerRef.value = res.data
  })
}
</script>

<style scoped lang="less">
// .slide-up-enter-active,
// .slide-up-leave-active {
//     transition: transform 0.5s ease-out;
// }

// /* 定义进入和离开的起始位置 */
// .slide-up-enter-from,
// .slide-up-leave-to {
//     transform: translateY(100%);
// }

.top-layout-main {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  width: 100vw;
  height: 100vh;
  position: relative;

  .top-layout-banner {
    width: 100%;
    position: relative;

    .banner-but {
      width: 25px;
      height: 25px;
      background-color: rgba(0, 0, 0, 0.322);
      position: absolute;
      top: 18px;
      right: 18px;
      cursor: pointer;
    }

    .banner-item {
      cursor: pointer;
    }

    .banner-img {
      display: block;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  .top-layout-content-box {
    flex: 1;
    overflow: auto;

    &::-webkit-scrollbar {
      width: 10px;
      height: 10px;
      transition: all 0.2s linear;
    }

    /* 滚动条轨道 */
    &::-webkit-scrollbar-track {
      border-radius: 4px;
    }

    /* 滚动条滑块 */
    &::-webkit-scrollbar-thumb {
      background-color: #90939930;
      border-radius: 4px;
    }

    /* 鼠标悬停在滚动条上的滑块 */
    &::-webkit-scrollbar-thumb:hover {
      background-color: #909399;
    }
  }
}
</style>
